import type {CancelablePromise} from '../types/CancelablePromise';
import type {SimilarVehicle} from '../types/SimilarVehicle';
import {request as __request} from '../utils/request';

export class VehicleService {
  /**
   * @returns SimilarVehicle
   * @throws ApiError
   */
  public static getSimilarVehicles({
    size,
    offset,
    vin,
    registrationPlateContains,
    authorization,
  }: {
    size?: number | null;
    offset?: number | null;
    vin?: string | null;
    registrationPlateContains?: string | null;
    authorization?: string;
  }): CancelablePromise<Array<SimilarVehicle>> {
    return __request({
      method: 'GET',
      url: '/dms/v1/vehicle/similar',
      shouldClearCacheEntry: true,
      headers: {
        Authorization: authorization,
      },
      query: {
        size,
        offset,
        vin,
        registrationPlateContains,
      },
    });
  }
}
